import { Component, inject } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { RouterOutlet } from '@angular/router'
import { environment } from '../environments/environment'
import { initializeGlobalErrorMessages } from './shared/magic/magic-form.messages'

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  constructor() {
    initializeGlobalErrorMessages()
    if (!environment.production) {
      inject(Title).setTitle(`OneDV Flexgate [${environment.name}]`)
    }
  }
}
